import { useContext } from "react";
import { FeatureConfigContext } from "@/contexts/FeatureConfigContext/FeatureConfigContext";

export const useFeatureConfig = () => {
  return useContext(FeatureConfigContext);
};
